import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import Container from '@amzn/awsui-components-console/container';
import Header from '@amzn/awsui-components-console/header';
import SpaceBetween from '@amzn/awsui-components-console/space-between';
import Button from '@amzn/awsui-components-console/button';
import Spinner from '@amzn/awsui-components-console/spinner';
import Box from '@amzn/awsui-components-console/box';
import { useStore } from 'src/stores/store';
import { Store } from 'src/stores/store.interface';
import ViewWorkflowContent from './ViewWorkflowContent';

export default function ViewWorkflow() {
	const history = useHistory();
	const location = useLocation();
	const searchParams = new URLSearchParams(location.search);
	const workflowId = searchParams.get('workflowId') || '';

	const resetStore = useStore((state: Store) => state.resetStore);
	const fetchWFDefinition = useStore((state: Store) => state.fetchWFDefinition);
	const isWFDefinitionLoading = useStore((state: Store) => state.isWFDefinitionLoading);
	const WFDefinitionError = useStore((state: Store) => state.WFDefinitionError);

	useEffect(() => {
		if (workflowId) {
			fetchWFDefinition(workflowId);
		}
	}, [workflowId, fetchWFDefinition]);

	useEffect(() => {
		return () => {
			resetStore();
		};
	}, [resetStore]);

	if (!workflowId) {
		return (
			<Container>
				<SpaceBetween size="l">
					<Header variant="h1">Invalid Workflow</Header>
					<Box>No workflow ID provided in the URL.</Box>
					<Button onClick={() => history.push('/manageWorkflows')}>
						Back to Manage Workflows
					</Button>
				</SpaceBetween>
			</Container>
		);
	}

	if (isWFDefinitionLoading) {
		return (
			<Container>
				<SpaceBetween size="l" alignItems="center">
					<Spinner size="large" />
					<Box>Loading workflow...</Box>
				</SpaceBetween>
			</Container>
		);
	}

	if (WFDefinitionError) {
		return (
			<Container>
				<SpaceBetween size="l">
					<Header variant="h1">Error Loading Workflow</Header>
					<Box>Failed to load workflow: {WFDefinitionError}</Box>
					<Button onClick={() => history.push('/manageWorkflows')}>
						Back to Manage Workflows
					</Button>
				</SpaceBetween>
			</Container>
		);
	}

	return <ViewWorkflowContent />;
}
